<template>
  <div class="game-table-flush">
    <vue-good-table
      styleClass="vgt-table condensed vgt-flush"
      v-bind="tableOptions"
      :columns="columns"
      :rows="rows"
      :search-options="searchOptions"
      :pagination-options="paginationFor(rows)"
      :sort-options="sortOptions"
      :row-click="true"
      @row-click="goToFinishedGame"
      compactMode
    >
      <template #table-row="props">
        <div v-if="props.column.field === 'Player'" class="d-flex flex-wrap align-items-center gap-2">
          <div
            v-for="player in (props.row.Player || [])"
            :key="player.UserID"
            class="d-flex align-items-center"
          >
            <img
              :src="userAvatarUrl(player.Img, store.state.imageCacheKey, true)"
              class="avatar avatar-xs me-2 result-avatar"
              :alt="player.Nick"
            >
            <span>{{ player.Nick }}</span>
          </div>
          <span v-if="!props.row.Player?.length">—</span>
        </div>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template #emptystate>
        <div class="text-center">
          <span>Žádné ukončené hry</span>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { tableOptions, tableSearchOptions, paginationFor, czechDateColumn } from '../../../../helpers/tableOptions';
import { userAvatarUrl } from '@/helpers/userAvatars';

defineProps({
  rows: Array
});

const store = useStore();
const router = useRouter();

const searchOptions = {
  ...tableSearchOptions,
  placeholder: 'Hledat hru…'
};

const sortOptions = {
  enabled: true,
  initialSortBy: { field: 'GameTo', type: 'desc' }
};

const formatFn = (value) => store.getters.formatTableNumber(value);

const goToFinishedGame = (params) => {
  const winner = params.row.Player?.[0];
  router.push({
    name: 'Ukončená hra',
    query: winner?.Nick ? { hrac: winner.Nick } : {},
    params: {
      gid: params.row.GameID,
      ...(winner?.UserID ? { pid: winner.UserID } : {})
    }
  });
};

const columns = reactive([
  {
    label: 'Hra',
    field: 'GameName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  {
    label: 'Od',
    field: 'GameFrom',
    ...czechDateColumn,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  {
    label: 'Do',
    field: 'GameTo',
    ...czechDateColumn,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  {
    label: 'Vklad',
    field: 'GameCredit',
    type: 'number',
    formatFn,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end',
  },
  {
    label: 'Kapitál',
    field: 'GameCapital',
    type: 'number',
    formatFn,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end',
  },
  {
    label: 'Vítěz',
    field: 'Player',
    sortable: false,
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
]);
</script>
